<template>
    <div :class="{'banner-silae-open': modalSilae}">
        <div class="banner-silae-top text-light" style="background:#d93914"><span class="pr-3">{{ $t('silae.banner')}}</span><a href="#" v-on:click="openMigrationModal(true)" class="py-1 btn btn-primary">{{ $t('silae.banner_link') }}</a></div>
        <div id="top-menu" class="d-flex justify-content-between" v-if="this.$Params.isMobile">
            <div class="logo"><img class="mw-100" :src="logoImage"></div>
            <div>
                <button class="mobile_menu" :class="{ 'open': menuOpen }" type="button" v-on:click="menuOpen = !menuOpen">
                    <div class="position-relative">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>
            </div>
        </div>
        <header class="top-right-buttons" v-if="!this.$Params.isMobile">
            <div>
                <b-dropdown variant="bg-white">
                    <template #button-content>
                        <i class="ms-Icon ms-Icon--Settings"></i> <span style="font-size: 15px;">{{ $t('menu.gestion')
                            }}</span>
                    </template>
                    <b-dropdown-item><router-link to="/change_password"><i
                                class="ms-Icon ms-Icon--PermissionsSolid"></i> <span>{{
            $t('menu.change_password') }}</span></router-link></b-dropdown-item>
                    <b-dropdown-item><router-link to="/configuration"><i
                                class="ms-Icon ms-Icon--ConfigurationSolid"></i> <span>{{
            $t('menu.configuration') }}</span></router-link></b-dropdown-item>
                </b-dropdown>
            </div>
            <a href="logout" v-on:click.prevent="logout"><i class="ms-Icon ms-Icon--OutOfOffice"></i> <span>{{
                $t('menu.close')
            }}</span></a>
        </header>
        <aside class="sidebar" :class="{ 'open': menuOpen }" style="top:0px">
            <div class="p-3 text-center" v-if="!this.$Params.isMobile">
                <router-link to="home"><img class="logo mw-100" :src="logoImage"></router-link>
            </div>
            <div class="menu">
                <ul class="list">
                    <li>
                        <div class="user-info">
                            <router-link to="home" class="image pl-0 waves-effect waves-block">
                                <img :src="urlAvatar" alt="User">
                            </router-link>
                            <div class="detail">
                                <small class="d-block"><strong>{{ userData.fullName }}</strong></small>
                                <small><i
                                        class="ms-Icon ms-Icon--Clock"></i><span>{{ userData.lastConnection }}</span></small>
                            </div>
                        </div>
                    </li>
                    <li v-for="(item, index) in menu" v-bind:key="index" v-wave="'ripple'">
                        <router-link @click.native="menuOpen = false" :to="item.path" active-class="active"><i
                                :class="item.meta.icon"></i><span>{{ $t('menu.' + item.name) }}</span></router-link>
                    </li>
                    <li v-if="this.$Params.isMobile">
                        <a href="logout" v-on:click.prevent="logout"><i class="ms-Icon ms-Icon--OutOfOffice"></i> <span>{{
                            $t('menu.close')
                        }}</span></a>
                    </li>
                </ul>
            </div>
        </aside>
        <section class="content">
            <div>
                <Breadcrumb />
                <div class="container-fluid">
                    <transition name="fade-router" mode="out-in">
                        <router-view />
                    </transition>
                </div>
            </div>
            <Footer></Footer>
        </section>

        <mmModal ref="modalMigracion" classe="modal-silae" size="lg" @visible="checkModal" :textClose="$t('cerrar')" :closable="false" :clickOutside="false">
            <div class="d-flex" v-if="showMigration==0">
                <div class="left-silae">
                    <div><img :src="this.$Params.urlBase + 'img/mysilae/logo.svg'" /></div>
                    <div><img :src="this.$Params.urlBase + 'img/mysilae/device.png'" /></div>
                </div>
                <div class="right-silae">
                    <div class="title py-3"> {{ $t('silae.title') }}</div>
                    <div v-html="$t('silae.text6').replace('{link}', '<a href=\'https://my.silae.es/sign-in\' class=\'text-secondary\' target=\'_blank\'><u><b>mySilae</b></u></a>')"></div>
                    <div class="py-4">
                        <div class="pb-2">{{ $t('silae.text1') }}</div>
                        <div class="pb-2">{{ $t('silae.text2') }}</div>
                        <div class="pb-2">{{ $t('silae.text3') }}</div>
                        <div class="pb-4">{{ $t('silae.text4') }}</div>
                        <p>{{ $t('silae.text5') }}</p>
                    </div>
                    <div class="form-group px-2">
                        <label>{{ $t('email') }}:</label>
                        <input id="email" type="text" class="form-control bg-light" v-model="userEmail" style="max-width: 350px;">
                        <div class="pt-3">
                            <i18n path="silae.text9" tag="p">
                                <a
                                    place="link"
                                    href="https://soporte.mysilae.es/hc/es/articles/30404643117586-Pol%C3%ADtica-de-privacidad-mySilae"
                                    target="_blank"
                                >
                                    {{ $t('silae.text9link') }}
                                </a>
                            </i18n>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex" v-if="showMigration==1">
                <div class="left-silae">
                    <div><img :src="this.$Params.urlBase + 'img/mysilae/logo.svg'" /></div>
                    <div><img :src="this.$Params.urlBase + 'img/mysilae/notification.png'" /></div>
                </div>
                <div class="right-silae">
                    <div class="title py-3">{{ $t('silae.title3') }}</div>
                    <div class="alert alert-silae"><b><i class="ms-Icon ms-Icon--Info"></i>{{ $t('silae.verification') }}</b><div>{{ $t('silae.validation_email') }} <b>({{ userEmail }})</b></div></div>
                    <div class="form-group px-2">
                        <label>{{ $t('Codigo') }}:</label>
                        <input id="email" type="text" class="form-control bg-light" v-model="emailCode" style="max-width: 350px;">
                    </div>
                </div>
            </div>
            <div class="d-flex" v-if="showMigration==2">
                <div class="left-silae">
                    <div><img :src="this.$Params.urlBase + 'img/mysilae/logo.svg'" /></div>
                    <div><img :src="this.$Params.urlBase + 'img/mysilae/employee.png'" /></div>
                </div>
                <div class="right-silae">
                    <div class="title py-3"> {{ $t('silae.title2') }}</div>
                    <div class="alert alert-silae success"><b><i class="ms-Icon ms-Icon--CheckMark"></i> {{ $t('silae.congratulations') }}</b><div>{{ $t('silae.active') }}</div></div>
                </div>
            </div>
            <template #buttons>
                <div class="alert alert-danger-silae" v-if="errorMsg">❌ {{ errorMsg }}</div>
                <div class="d-flex justify-content-end">
                    <a href="#" @click.prevent="closeModalMigration" class="btn btn-sm btn-light mr-3">{{ $t('cerrar') }}</a>
                    <mmButton :click="sendMigration" text="Continuar &rarr;" classe="btn btn-sm btn-primary" v-if="showMigration == 0 || showMigration == 1"></mmButton>
                </div>
            </template>
        </mmModal>
        <mmModal ref="modalInfoEmail" :title="$t('atencion')" :textClose="$t('cerrar')">
            <div class="pb-5 text-center">
                {{ $t('alert_email') }}
            </div>
            <div class="form-group">
                <label>{{ $t('email') }}:</label>
                <input id="email" type="text" class="form-control" v-model="userEmail">
            </div>
            <template #buttons>
                <a href="#" @click.prevent="updateEmailUser" class="btn btn-primary">{{ $t('save') }}</a>
                <a href="#" @click.prevent="noShowEmailModal" class="btn btn-warning">{{ $t('dont_show_more') }}</a>
            </template>
        </mmModal>
        <mmModal ref="modalAuthenticator" size="md" :title="$t('validateCode')" v-if="visibleModalAuthenticator">
            <div>
                <p>{{ $t('enterCode') }}</p>
                <div class="form-group">
                    <label>{{ $t('code') }}</label>
                    <input type="text" name="codeAuthenticator" v-model="userModel.code" class="form-control" />
                </div>
            </div>
            <template #buttons>
                <a href="#" @click.prevent="updateDataUser" class="btn btn-primary">{{ $t('save') }}</a>
            </template>
        </mmModal>
    </div>
</template>

<style>
.top-right-buttons {
    position: absolute;
    top: 0;
    right: 0;
    padding-right: 5px;
    display: flex;
    gap: 15px;
    margin-right: 20px;
}

.top-right-buttons a {
    color: #000;
    /* Adjust color as needed */
    text-decoration: none;
    display: flex;
    align-items: center;
}

.top-right-buttons a i {
    margin-right: 5px;
}
</style>

<script>
import Breadcrumb from '@/views/layout/Breadcrumb.vue';
import mmModal from '@mysummar/summar-vue/src/components/mmModal.vue'
import mmButton from '@mysummar/summar-vue/src/components/mmButton.vue'
import { userService } from '@/api/user';
import Footer from '@/views/layout/Footer.vue';
import { localize } from "vee-validate";
import { langValidate } from '@/_helpers/lang/localize';
import Cookies from 'js-cookie';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'Layout',
    data() {
        return {
            visibleModalAuthenticator: false,
            userData: [],
            userEmail: '',
            emailCode: '',
            urlAvatar: '',
            menu: [],
            menuOpen: false,
            showMigration: -1,
            errorMsg: '',
            modalSilae: false,
            logoImage: `${this.$Params.urlImages}logo`
        }
    },
    components: {
        Footer,
        Breadcrumb,
        mmModal,
        mmButton
    },
    computed: {
        ...mapGetters(['getUserData']),
    },
    async mounted() {
        await this.fetchUserData();
        this.userData = this.getUserData;

        if(this.userData.mySilae==1) {
            this.openMigrationModal();
        }   

        let showInformedEmailStorage = localStorage.getItem('informed-email-pdoc');
        //si el usuario no tiene el email informado o aun no a clicado en noMostrar, mostramos Modal para actualizar su Email
        if (this.userData.informedEmail == 0 && showInformedEmailStorage == null && this.$Params.recover == '2') {
            this.$refs.modalInfoEmail.show();
        }

        this.urlAvatar = `${this.$Params.urlBase}img/avatar-${this.userData.userType}.jpg`;
        this.menu = this.$router.options.routes.find(e => e.name === 'Layout').children.filter(item => item.meta.hide == undefined || !item.meta.hide);

            
            this.$i18n.locale = (this.userData.language !== '') ? this.userData.language : 'es';
            localize(this.userData.language, langValidate[this.userData.language]);
            

        //redireccio porque es obligatorio el authenticator
        let _cookieChangePassword = Cookies.get("needChangePassword");
        _cookieChangePassword === 'undefined' ? false : _cookieChangePassword;

        if (this.$Params.authenticator == '2' && this.userData.authenticator == 0 && _cookieChangePassword) {
            this.$Params.requires_authenticator = '1';
            this.$router.push('/configuration');
        }

        this.$Params.user_authenticator = (this.$Params.authenticator != '0' && this.userData.authenticator == 1) ? 1 : 0;
    },
    methods: {
        ...mapActions(['fetchUserData']),
        logout() {
            userService.logout();
            this.$router.push('/');
        },
        async updateEmailUser() {
            let response = await userService.userEmailInform(this.userEmail);
            if (response) {
                this.userEmail = '';
                this.$refs.modalInfoEmail.hide();
            }
        },
        async sendMigration() {
            
            this.errorMsg = '';
            if(this.showMigration == 0) {
                let response = await userService.sendMigration(this.userEmail);
                
                if(response===true) {
                    this.$posthog.capture('Activation Email Submitted', {client: this.userData.client, company: this.userData.empresa})
                    this.showMigration = 1;
                }
                else
                    this.errorMsg = response.message;

            } else {
                this.$posthog.capture('Activation Code 2FA Submitted', {client: this.userData.client, company: this.userData.empresa})
                let response = await userService.validationMigration(this.emailCode);
                
                if(response===true) {
                    this.$posthog.capture('Activation Completed', {client: this.userData.client, company: this.userData.empresa})
                    this.showMigration = 2;
                }
                else
                    this.errorMsg = response.message;
            }
        },
        noShowEmailModal() {
            this.$refs.modalInfoEmail.hide();
            localStorage.setItem('informed-email-pdoc', 1);
        },
        openMigrationModal(origin) {
            this.userEmail = this.userData.email;
            this.showMigration = 0;
            this.emailCode = '';
            this.errorMsg = '';
            this.$refs.modalMigracion.show();
            
            if(origin)
                this.$posthog.capture('Activation Banner Clicked', {client: this.userData.client, company: this.userData.empresa})
            else
                this.$posthog.capture('Activation Popup Shown', {client: this.userData.client, company: this.userData.empresa})
        },
        closeModalMigration() {
            this.$refs.modalMigracion.hide();
        },
        checkModal(status) {
            if(this.showMigration == 2)
                this.modalSilae = 0;
            else
                this.modalSilae = !status;

            if(!status)
                this.$posthog.capture('Activation Popup Dismissed', {client: this.userData.client, company: this.userData.empresa})
        }
    },
}
</script>

<style>
.fade-router-enter-active,
.fade-router-leave-active {
    transition: all .3s;
}

.fade-router-enter,
.fade-router-leave-active {
    opacity: 0;
    transform: translateY(20px);
}

.fade-router-move {
    transition: all .3s;
}

.fade-router-leave-active {
    position: absolute;
}
</style>